export enum ArticlesAssignedDataIndex {
  'internal_name' = 'internal_name',
  'internal_id' = 'internal_id',
  'has_audio' = 'has_audio',
  'title' = 'title',
  'completion_status' = 'completion_status',
}
